<!-- Generated template for the TrophyComponent component -->

<div class="trophy-container" #container1>
	<div class="trophy-loader">
		<div class="spinner-container">
			<ion-spinner item-start></ion-spinner>
			<p>{{'TROPHY_LOADING_HEADLINE' | translate}}</p>
			<p text-small>{{'TROPHY_LOADING_TEXT' | translate}}</p>
		</div>
	</div>
</div>
<div class="textures">
	<img class="certBg" src='assets/trophy/textures/urkunde3.png' alt='Texture' />
	<img class="spooortsLogo" src="assets/trophy/Spooorts_logo_engraved@0.5x.png" alt='Logo' />
	<img class="hannoverLogo" src="assets/trophy/textures/marathon-hannover-logo.png" alt='Logo' />
	<img class="hannoverDate" src="assets/trophy/textures/marathon-hannover-date.png" alt='Date texture' />
	<img class="hannoverTexture" src="assets/trophy/textures/hannover_medal_texture.png" alt='Medal texture' />
</div>

<div class="trophy-container" #container2>
	<div class="trophy-loader">
		<div class="spinner-container">
			<ion-spinner item-start></ion-spinner>
			<p>{{'TROPHY_LOADING_HEADLINE' | translate}}</p>
			<p text-small>{{'TROPHY_LOADING_TEXT' | translate}}</p>
		</div>
	</div>
</div>
<div class="textures">
	<img class="certBg" src='assets/trophy/textures/urkunde3.png' alt='Texture' />
	<img class="spooortsLogo" src="assets/trophy/Spooorts_logo_engraved@0.5x.png" alt='Logo' />
	<img class="hannoverLogo" src="assets/trophy/textures/marathon-hannover-logo.png" alt='Logo' />
	<img class="hannoverDate" src="assets/trophy/textures/marathon-hannover-date.png" alt='Date texture' />
	<img class="hannoverTexture" src="assets/trophy/textures/hannover_medal_texture.png" alt='Medal texture' />
</div>